import "katex/dist/katex.min.css";

import type { FC } from "react";
import { Form } from "react-bootstrap";
import Latex from "react-latex-next";

import SelfEvaluationTask from "features/SelfEvaluation/Practice/Task";
import Layout from "./_Layout";

import type { UserAssignmentDetailFragment } from "api/generated";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { selectSimpleAnswer, setSimpleAnswer } from "store/slices/answer";

import { AssignmentImage } from "components/AssignmentImage";
import { AssignmentPrompt } from "components/AssignmentPrompt";
import { useAssetUrlResolver } from "utils/hooks/useAssetUrlResolver";

/* W8WhtjNybz8RcI7cG4mQ */

interface Props {
  data: UserAssignmentDetailFragment;
  onSubmit: () => void;
}

const ViceJednoslovnychOdpovedi: FC<Props> = ({ data, onSubmit }) => {
  const questionsCount = data.assignment?.assignment?.questions.length;
  const isSelfEvaluation = data.assignment?.scoring?.scoringMethod?.scoringMethod === "sebeopravení";

  const selected = useAppSelector(selectSimpleAnswer);
  const dispatch = useAppDispatch();
  const imageUrl = useAssetUrlResolver(data.assignment?.assignment?.assignmentImage);
  const thumbHash = data.assignment?.assignment?.assignmentImageThumbHash;
  const imageDimensions = data.assignment?.assignment?.AssignmentImageDimensions;

  const handleChange = (index: number, value: string) => {
    const newAnswers = selected.length === 0 ? new Array(questionsCount).fill("") : [...selected];
    newAnswers[index] = value;

    dispatch(setSimpleAnswer(newAnswers));
  };

  const areAnswersFilled = () => selected.length > 0 && selected.every(answer => answer.length > 0);

  if (isSelfEvaluation) {
    return <SelfEvaluationTask userAssignment={data} onSubmit={onSubmit} />;
  }

  return (
    <Layout onSubmit={onSubmit} isSubmitDisabled={!areAnswersFilled()}>
      <div>
        <AssignmentPrompt assignment={data.assignment?.assignment} />

        <div className="mt-20px question">
          <Latex>{data.assignment?.assignment?.questionsText ?? ""}</Latex>

          {data.assignment?.assignment?.questions.map((question, qIndex) => (
            <div key={qIndex} className="mt-20px ">
              <Latex>{question.heading ?? ""}</Latex>
              {!!data.assignment?.assignment?.assignmentImage && (
                <AssignmentImage
                  src={imageUrl}
                  thumbHash={thumbHash}
                  width={imageDimensions?.width}
                  height={imageDimensions?.height}
                />
              )}

              <Form.Control
                placeholder={question.placeholder ?? ""}
                onChange={event => {
                  handleChange(qIndex, event.target.value);
                }}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
              ></Form.Control>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default ViceJednoslovnychOdpovedi;
